import React from "react";
import style from "./index.module.scss";
import { Link } from "react-router-dom";
import { NoWeekTimeCourse } from "service/course";
import Config from "config";
import { courseDetailUrlNoWeekId } from "service/url";
import { Badge, Dropdown, Icon, Menu, Tooltip } from "antd";
import copyIcon from "./images/copyIcon.png";
import {
    CourseItem as CourseItemProps,
    toNumber
} from "../../../../../service/service";
import { stopJump } from "../../../../../utils/common";
import useStorage from "../../../../../utils/useStorage";
interface IProps {
    className?: string;
    data: NoWeekTimeCourse;
    imgUrl: string;
}

function CourseItem({ className, data, imgUrl }: IProps) {
    const {
        courseName,
        courseNo,
        courseSeq,
        weekTimeId,
        channelId,
        isOpen,
        teacherName,
        batchNo,
        evaluationStatus,
        evaluationReadStatus,
        evaluationId,
        evaluationList
    } = data;

    const linkUrl = `/course/detail/${weekTimeId}/${batchNo}/${courseNo}/${courseSeq}`;

    const menu = (
        <Menu style={{ width: "120px", padding: "0px", textAlign: "center" }}>
            <Menu.Item className={style.menu}>
                <a
                    target="_blank"
                    onClick={event =>
                        stopJump(
                            `${Config.LiveUrl}?courseNo=${courseNo}&courseSeq=${courseSeq}&batchNo=${batchNo}&customerCode=${Config.CustomCode}&channelId=${channelId}`,
                            event
                        )
                    }
                    rel="noopener noreferrer">
                    网页直播
                </a>
            </Menu.Item>
            <Menu.Item className={style.menu}>
                <a
                    target="_blank"
                    onClick={event =>
                        stopJump(
                            `${Config.LiveUrlClient}?courseNo=${courseNo}&courseSeq=${courseSeq}&batchNo=${batchNo}&customerCode=${Config.CustomCode}&channelId=${channelId}`,
                            event
                        )
                    }
                    rel="noopener noreferrer">
                    客户端直播
                </a>
            </Menu.Item>
        </Menu>
    );

    const [teacherNo] = useStorage("teacherNo");
    const evaluateMenu = (
        <Menu>
            {evaluationList
                .filter(item => {
                    if (item.isDeputy === "0") {
                        return true;
                    }
                    if (item.isDeputy === "1") {
                        if (item.teacherNo === teacherNo) {
                            return true;
                        }
                    }

                    return false;
                })
                .map(item => {
                    return (
                        <Menu.Item key={item.evaluationId}>
                            <Link
                                to={`/evaluate/${item.evaluationId}?isDeputy=${item?.isDeputy}`}>
                                {item.evaluationName}
                            </Link>
                        </Menu.Item>
                    );
                })}
        </Menu>
    );

    return (
        <div className={`${style.root} ${className}`}>
            <div className={style.main}>
                <Link to={linkUrl}>
                    <img className={style.img} src={imgUrl} alt="" />
                    <div className={style.title}>{courseName}</div>
                </Link>
                <div className={style.info}>
                    <span className={style.flex}>
                        课程号
                        <Tooltip placement="topLeft" title={courseNo}>
                            <span className={style.courseNo}>{courseNo}</span>
                        </Tooltip>
                    </span>
                    <span>编号 {courseSeq}</span>
                </div>
                <div className={style.line} />
                <div className={`${style.itemWrapper}`}>
                    <div className={style.item}>
                        <Link
                            to={`/classes/${weekTimeId}/${batchNo}/${courseNo}/${courseSeq}/class`}>
                            <img src={require("./images/icon.png")} alt="" />
                            <span>学员</span>
                        </Link>
                    </div>
                    <div className={style.item}>
                        <Link
                            to={`/course/${batchNo}/${courseNo}/${courseSeq}/score`}>
                            <img src={require("./images/icon2.png")} alt="" />
                            <span>成绩</span>
                        </Link>
                    </div>
                    <div className={style.item}>
                        <Link to={`/course/${courseNo}/${courseSeq}/analyse`}>
                            <img src={require("./images/icon4.png")} alt="" />
                            <span>分析</span>
                        </Link>
                    </div>
                    <div className={style.item}>
                        <Link
                            to={courseDetailUrlNoWeekId(
                                {
                                    courseNo,
                                    courseSeq,
                                    batchNo,
                                    weekTimeId: toNumber(weekTimeId)
                                } as CourseItemProps,
                                "/courseChapters"
                            )}>
                            <img src={require("./images/icon6.png")} alt="" />
                            <span>章节</span>
                        </Link>
                    </div>
                    <div className={style.item}>
                        <Link
                            to={`/course/${courseNo}/${courseSeq}/${courseName}/${teacherName}/invitatinCode`}>
                            <img src={copyIcon} alt="" />
                            <span>邀请码</span>
                        </Link>
                    </div>
                    {evaluationStatus === "1" && (
                        <div className={style.item}>
                            <Dropdown
                                overlay={evaluateMenu}
                                placement="bottomCenter">
                                <div className={style.box}>
                                    <Badge
                                        dot
                                        count={
                                            evaluationReadStatus !== "1" ? 1 : 0
                                        }>
                                        <Icon type="pie-chart" />
                                    </Badge>

                                    <span>评教</span>
                                </div>
                            </Dropdown>
                        </div>
                    )}
                    {!!channelId && (
                        <div className={style.item}>
                            <Link
                                to={`/course/${courseNo}/${courseSeq}/${courseName}/${channelId}/liveRecord`}>
                                <img
                                    src={require("./images/icon5.png")}
                                    alt=""
                                />
                                <span>直播记录</span>
                            </Link>
                        </div>
                    )}

                    {/*<div className={style.item} style={{visibility: "hidden"}}>*/}
                    {/*    <img src={require('./images/icon3.png')} alt=""/>*/}
                    {/*    <span>下载</span>*/}
                    {/*</div>*/}
                </div>
                {/*<div className={style.line} />*/}
                {/*<div className={style.footer}>*/}
                {/*    {isOpen === "1" && (*/}
                {/*        <Dropdown*/}
                {/*            overlay={menu}*/}
                {/*            className={style.live}*/}
                {/*            placement="bottomCenter">*/}
                {/*            <a>*/}
                {/*                去直播 <Icon type="down" />*/}
                {/*            </a>*/}
                {/*        </Dropdown>*/}
                {/*    )}*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default CourseItem;
